const COUNTRY_FLAGS = {
  'United Kingdom': '🇬🇧',
  'South Africa': '🇿🇦',
  'United States': '🇺🇸',
  'New Zealand': '🇳🇿',
  'Bosnia and Herzegovina': '🇧🇦',
  Ukraine: '🇺🇦',
  France: '🇫🇷',
  USA: '🇺🇸',
  Spain: '🇪🇸',
  Germany: '🇩🇪',
  Italy: '🇮🇹',
  Australia: '🇦🇺',
  Canada: '🇨🇦',
  Ireland: '🇮🇪',
  Zimbabwe: '🇿🇼',
  Russia: '🇷🇺',
  Brazil: '🇧🇷',
  Malta: '🇲🇹',
  Barbados: '🇧🇧',
  Nigeria: '🇳🇬',
  Latvia: '🇱🇻',
  Sweden: '🇸🇪',
  Belgium: '🇧🇪',
  Turkey: '🇹🇷',
  Slovakia: '🇸🇰',
  Greece: '🇬🇷',
  Croatia: '🇭🇷',
  Poland: '🇵🇱',
  Lithuania: '🇱🇹',
  Austria: '🇦🇹',
  Slovenia: '🇸🇮',
  Bulgaria: '🇧🇬',
  Japan: '🇯🇵',
  Singapore: '🇸🇬',
  Serbia: '🇷🇸',
  Finland: '🇫🇮',
  Mauritius: '🇲🇰',
  'Hong Kong': '🇭🇰',
  Switzerland: '🇨🇭',
  Hungary: '🇭🇺',
  Norway: '🇳🇴',
  Denmark: '🇩🇰',
  Portugal: '🇵🇹',
  Netherlands: '🇳🇱',
  Colombia: '🇨🇴',
  Romania: '🇷🇴',
};

export const getCountryFlag = (country) => COUNTRY_FLAGS[country] || '🎰';

export const isBallBasedMarket = (type) =>
  type === 'BALLS' || type === 'BONUS_BALL';

export const isDirectClickMarket = (market) =>
  market.outcomes?.some(
    (outcome) =>
      outcome.outcome_type === 'BALLS' || outcome.outcome_type === 'BONUS_BALL'
  ) ?? false;

export const calculatePotentialPayout = (
  stake,
  odds,
  singleBetsCount,
  repeatForDraws = 1
) => Math.round(stake * Number(odds) * singleBetsCount * repeatForDraws * 100);

export const formatOdds = (odds) => {
  const numeric = Number(odds);
  if (odds === null || odds === undefined || Number.isNaN(numeric)) return '-';
  const [intPart, decPart] = numeric.toFixed(2).split('.');
  return `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${decPart}`;
};

const CURRENCY_PREFIX = {
  ZAR: 'R',
  USD: '$',
  EUR: '€',
  GBP: '£',
};

export const formatBalance = (minorUnits, currency = 'ZAR') => {
  const value = (Number(minorUnits) || 0) / 100;
  const parts = value.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const prefix = CURRENCY_PREFIX[currency] ?? `${currency} `;
  return `${prefix}${parts.join('.')}`.trim();
};
